import { LucideIcon } from "lucide-react";
import { artGradient, hueFromId } from "@/lib/showcaseData";

interface ArtBlockProps {
  seed: string;
  icon: LucideIcon;
  className?: string;
  label?: string;
  hue?: number;
}

/** Generated artwork placeholder so cards without an image still look designed. */
const ArtBlock = ({ seed, icon: Icon, className = "h-40 w-full", label, hue }: ArtBlockProps) => {
  const h = hue ?? hueFromId(seed);
  return (
    <div className={`relative overflow-hidden ${className}`} style={{ backgroundImage: artGradient(h) }}>
      <div className="absolute inset-0 opacity-25 mix-blend-overlay" style={{ backgroundImage: "repeating-linear-gradient(115deg, rgba(255,255,255,.35) 0 2px, transparent 2px 12px)" }} />
      <div className="absolute inset-0 flex items-center justify-center">
        <Icon className="w-8 h-8 text-white/85 drop-shadow" />
      </div>
      {label && (
        <span className="absolute bottom-2 left-2 rounded-full bg-black/55 px-2 py-0.5 text-[10px] uppercase tracking-wide text-white/90 backdrop-blur">
          {label}
        </span>
      )}
    </div>
  );
};

export default ArtBlock;
